import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { CONTROL_HEIGHT, INK } from "../../../../theme/tokens";
import { type DropdownItem, SystemDropdown } from "../../../UIToolkit/Inputs/SystemDropDown";

type Props = {
	/** "All departments (entire facility)" first, then the building's departments. */
	options: DropdownItem<string>[];
	pickedOptionIds: string[];
	onChange: (pickedOptionIds: string[]) => void;
};

/**
 * The composer's Department row: what it filters by, then which of the building's departments get the message.
 * "All departments (entire facility)" is a row of its own — the whole building, staff in no department included —
 * so the dropdown has no Select-all.
 */
export const DepartmentFilterRow: FC<Props> = ({ options, pickedOptionIds, onChange }) => {
	const { t } = useTranslation();
	return (
		<Box sx={{ display: "flex", gap: 2, width: "100%", alignItems: "center" }} data-testid="broadcast-department-row">
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					flex: "0 0 30%",
					height: CONTROL_HEIGHT.STANDARD,
					px: 1.75,
					borderRadius: 1,
					border: `1px solid ${alpha(INK.SECONDARY, 0.25)}`,
				}}
			>
				<Typography variant="body2">{t("broadcast.departments.kind")}</Typography>
			</Box>
			<SystemDropdown
				items={options}
				selectedItems={pickedOptionIds}
				multiple={true}
				// DEFAULT: the dropdown reports a cleared selection as undefined; it means nothing picked.
				onChangeMultiple={(picked) => onChange(picked ?? [])}
				allOption=""
				search={{ placeholder: t("broadcast.departments.search") }}
				formControlSx={{ flex: 1, minWidth: 0 }}
				data-testid="broadcast-departments-filter"
			/>
		</Box>
	);
};
